import React, { useEffect, useState } from 'react';
import SearchableSelect from '../common/SearchableSelect';
import { ItemService } from '../../services/item.service';
import { Item } from '../../interfaces/item.interface';
import { helpElement } from '../../help/attrs';

interface Props {
  value: string | null;
  /** Label of the current value when it is not in the first page of results (an edited order line). */
  valueLabel?: string;
  onChange: (id: string, item: Item | null) => void;
  label?: string;
  size?: 'small' | 'medium';
  sx?: object;
  /** Only items of this kind (STOCK / SERVICE / KIT); all kinds when absent. */
  kind?: string;
  fullWidth?: boolean;
  'data-testid'?: string;
  'data-help'?: string;
}

/** Item picker that searches on the server as the user types (no fixed-size preload). */
const SalesItemSearchSelect: React.FC<Props> = ({
  value, valueLabel, onChange, label = 'Item', size = 'small', sx, kind, fullWidth, 'data-testid': testId, 'data-help': dataHelp,
}) => {
  const [options, setOptions] = useState<Item[]>([]);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let live = true;
    setLoading(true);
    const t = setTimeout(() => {
      (kind ? ItemService.getItemsByInstitution(0, 30, text, kind) : ItemService.getItemsByInstitution(0, 30, text))
        .then(r => { if (live) setOptions(r.content ?? []); })
        .catch(() => { if (live) setOptions([]); })
        .finally(() => { if (live) setLoading(false); });
    }, 250);
    return () => { live = false; clearTimeout(t); };
  }, [text, kind]);

  const selectedOption: Item | undefined = value && valueLabel
    ? { id: value, itemCode: valueLabel, itemName: '', description: '', lotTracked: false, itemCategoryId: '' }
    : undefined;

  return (
    <SearchableSelect<Item>
      label={label} size={size} sx={sx} fullWidth={fullWidth} data-testid={testId} {...helpElement(dataHelp)} options={options} value={value} selectedOption={selectedOption} clearable
      loading={loading} disableClientFilter onInputChange={setText}
      getOptionLabel={i => (i.itemName ? `${i.itemCode} - ${i.itemName}` : i.itemCode)} getOptionId={i => i.id ?? ''}
      onChange={(id, opt) => onChange(id, opt)}
    />
  );
};

export default SalesItemSearchSelect;
